import React from "react";
import { Link } from "react-router-dom";
import { useBrand } from "@/lib/brand";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  const brand = useBrand();
  return (
    <footer className="mt-24 bg-[#05070C] border-t border-[#142542]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          {brand.logo_url && <img src={brand.logo_url} alt={brand.name} className="h-12 mb-6" />}
          <p className="text-sm text-[#94A3B8] max-w-md leading-relaxed">
            Connecting retired professionals with ambitious businesses. Experience meets purpose in our curated marketplace.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="label-eyebrow mb-5">Quick Links</div>
          <ul className="space-y-3 text-sm text-[#CBD5E1]">
            <li><Link to="/" className="hover:text-[#2DD4BF]">Home</Link></li>
            <li><Link to="/about" className="hover:text-[#2DD4BF]">About Us</Link></li>
            <li><Link to="/professionals" className="hover:text-[#2DD4BF]">Browse Experts</Link></li>
            <li><Link to="/match" className="hover:text-[#2DD4BF]">AI Match</Link></li>
            <li><Link to="/pricing" className="hover:text-[#2DD4BF]">Pricing</Link></li>
            <li><Link to="/faq" className="hover:text-[#2DD4BF]">FAQs</Link></li>
            <li><Link to="/contact" className="hover:text-[#2DD4BF]">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-5">
          <div className="label-eyebrow mb-5">Contact Us</div>
          <ul className="space-y-3 text-sm text-[#CBD5E1]">
            {brand.phone && (
              <li className="flex items-start gap-3">
                <Phone className="h-4 w-4 text-[#2DD4BF] mt-0.5" />
                <a href={`tel:${brand.phone}`} className="hover:text-[#2DD4BF]">{brand.phone}</a>
              </li>
            )}
            {brand.whatsapp && (
              <li className="flex items-start gap-3">
                <span className="text-[#2DD4BF] text-xs font-semibold mt-1">WA</span>
                <a href={`https://wa.me/${brand.whatsapp.replace(/\D/g, "")}`} target="_blank" rel="noreferrer" className="hover:text-[#2DD4BF]">{brand.whatsapp}</a>
              </li>
            )}
            {brand.email && (
              <li className="flex items-start gap-3">
                <Mail className="h-4 w-4 text-[#2DD4BF] mt-0.5" />
                <a href={`mailto:${brand.email}`} className="hover:text-[#2DD4BF] break-all">{brand.email}</a>
              </li>
            )}
            {brand.address && (
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 text-[#2DD4BF] mt-0.5" />
                <span>{brand.address}</span>
              </li>
            )}
          </ul>
        </div>
      </div>

      <div className="border-t border-[#142542]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-wrap gap-4 justify-between text-xs text-[#64748B]">
          <span>© 2026 {brand.name}. All rights reserved.</span>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-[#2DD4BF]">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-[#2DD4BF]">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
